import React from 'react';
import Img from 'react-image';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import styles from './about.module.scss';
import aboutImg from '../../img/about.jpg';

let cx = classNames.bind(styles);

const About = () => {
	const { t } = useTranslation();

	return (
		<section id='about-us' className={cx({ about: true })}>
			<div className='flex flex-col lg:flex-row w-full'>
				<div className='flex flex-col w-full lg:w-1/2'>
					<Img src={aboutImg} className='w-full' />
				</div>
				<div className='flex flex-col w-full lg:w-1/2 bg-white p-10 lg:py-32 lg:pl-16 lg:pr-32 lg:justify-center'>
					<h1 className='font-HelveticaNeueLTStd-Bold text-telus-purple text-2xl lg:text-3xl py-4'>
						About Telus International
					</h1>
					<p className='font-HelveticaNeueLTStd-Roman text-telus-dark text-xl lg:text-2xl'>
						As the global arm of TELUS – a leading Canadian telecommunications
						company – we employ over 50,000 people with presence in El Salvador,
						Guatemala, United States, Canada, Romania, Bulgaria, India, China,
						Irlanda and the Philippines. Being global allows us to serve
						customers in over 50 languages and also makes us unique, resulting
						in a blend of different cultures, complemented by our company
						values.
					</p>
				</div>
			</div>
			<div className='flex flex-col lg:flex-row w-full lg:py-10'>
				<div className='flex flex-col w-full lg:w-2/5 bg-white p-10 lg:pt-0 lg:pl-16 lg:pr-20'>
					<h1 className='font-HelveticaNeueLTStd-Bold text-telus-purple text-2xl lg:text-3xl py-4'>
						Virtual Site Tour: Central America:
					</h1>
					<p className='font-HelveticaNeueLTStd-Roman text-telus-dark text-xl lg:text-2xl'>
						Looking to expand your technical support, customer experience,
						and/or digital solutions capabilities? TELUS International Central
						America offers numerous sites throughout El Salvador and Guatemala
						focused on operational excellence and customer satisfaction. From
						client-branded floors, to themed meeting rooms, to fitness
						facilities, to our onsite university classes, and even a daycare –
						it’s no wonder our team members are so engaged when it comes to
						serving our global clients.
					</p>
				</div>
				<div className='flex flex-col w-full lg:w-3/5 lg:justify-center lg:items-center'>
					<iframe
						width='700'
						height='415'
						src='https://www.youtube-nocookie.com/embed/1_iEz8SVocI?showinfo=0&rel=0&autoplay=0&controls=0'
						frameborder='0'
						allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
						allowfullscreen
						className='hidden lg:block'
					></iframe>
					<iframe
						width='100%'
						height='200px'
						src='https://www.youtube-nocookie.com/embed/1_iEz8SVocI?showinfo=0&rel=0&autoplay=0&controls=0'
						frameborder='0'
						allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
						allowfullscreen
						className='lg:hidden'
					></iframe>
				</div>
			</div>
		</section>
	);
};

export default About;
